export default "__VITE_ASSET__KRmhkee4__"